import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../../design-system/atoms/Text/Text';
export interface WelcomeEnjoyKakaoTextBoxProps
  extends HTMLAttributes<HTMLDivElement> {
  title: string;
  desc1: string;
  desc2: string;
}

export function WelcomeEnjoyKakaoTextBox({
  title,
  desc1,
  desc2,
  className,
  ...props
}: WelcomeEnjoyKakaoTextBoxProps) {
  return (
    <div
      className={twMerge('flex flex-col items-center', className)}
      {...props}
    >
      <Text
        className={twMerge(
          'rounded-[100px] bg-theme-solid-100 py-4pxr px-12pxr',
          'font-small2-bold text-theme-solid-10'
        )}
      >
        {title}
      </Text>
      <Text className="font-medium1-bold mt-16pxr px-24pxr text-center text-theme-solid-100">
        {desc1} <br />
        {desc2}
      </Text>
    </div>
  );
}
